// @flow

export const GET_INSTRUCTOR_INFO: string = 'GET_INSTRUCTOR_INFO';

export const daysOfWeekLabels: $ReadOnlyArray<string> = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat'
];
